import React from 'react';

export function CsvImportModal({
  showCsvMapping, setShowCsvMapping,
  canEdit,
  csvProfile, setCsvProfile,
  csvHeaders, csvRows,
  csvRoles, csvSelection,
  toggleCsvSelection,
  recomputeCsvRoles,
  applyCsvImport,
  relevantHeaders
}) {
  if (!showCsvMapping || !canEdit) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2000
      }}
    >
      <div
        style={{
          background: '#111',
          color: '#eee',
          padding: 24,
          borderRadius: 8,
          minWidth: 700
        }}
      >
        <h2>Associer les colonnes du CSV</h2>

        {/* Onglets de profil */}
        <div
          style={{
            display: 'flex',
            gap: 8,
            marginBottom: 12,
            borderBottom: '1px solid #333',
            paddingBottom: 8
          }}
        >
          <button
            type="button"
            onClick={() => {
              setCsvProfile('bricoCasto');
              recomputeCsvRoles(csvHeaders, 'bricoCasto');
            }}
            style={{
              padding: '6px 12px',
              borderRadius: 4,
              border: csvProfile === 'bricoCasto' ? '2px solid #fff' : '1px solid #555',
              background: csvProfile === 'bricoCasto' ? '#333' : '#222',
              color: '#fff',
              cursor: 'pointer'
            }}
          >
            Brico / Casto
          </button>
          <button
            type="button"
            onClick={() => {
              setCsvProfile('leroy');
              recomputeCsvRoles(csvHeaders, 'leroy');
            }}
            style={{
              padding: '6px 12px',
              borderRadius: 4,
              border: csvProfile === 'leroy' ? '2px solid #fff' : '1px solid #555',
              background: csvProfile === 'leroy' ? '#333' : '#222',
              color: '#fff',
              cursor: 'pointer'
            }}
          >
            Leroy Merlin
          </button>
          <button
            type="button"
            onClick={() => {
              setCsvProfile('goxl');
              recomputeCsvRoles(csvHeaders, 'goxl');
            }}
            style={{
              padding: '6px 12px',
              borderRadius: 4,
              border: csvProfile === 'goxl' ? '2px solid #fff' : '1px solid #555',
              background: csvProfile === 'goxl' ? '#333' : '#222',
              color: '#fff',
              cursor: 'pointer'
            }}
          >
            GOXL
          </button>
        </div>

        <table
          border="1"
          cellPadding="6"
          style={{ width: '100%', marginTop: 8, borderColor: '#333' }}
        >
          <thead>
            <tr>
              <th>Colonne CSV</th>
              <th>Importer ?</th>
              <th>Aperçu (1ère ligne)</th>
            </tr>
          </thead>
          <tbody>
            {relevantHeaders.map((header) => {
              const index = csvHeaders.indexOf(header);
              return (
                <tr key={header}>
                  <td>{header}</td>
                  <td style={{ textAlign: 'center' }}>
                    <input
                      type="checkbox"
                      checked={!!csvSelection[header]}
                      onChange={() => toggleCsvSelection(header)}
                    />
                  </td>
                  <td>{csvRows[0]?.[index] ?? ''}</td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div
          style={{
            marginTop: 16,
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 8
          }}
        >
          <button onClick={() => setShowCsvMapping(false)}>Annuler</button>
          <button onClick={applyCsvImport}>Importer</button>
        </div>
      </div>
    </div>
  );
}
